import { APIOrgMemberRole } from "../API/APIOrgMember"

export const OrgPermissionScopes = [
    "member:view",
    "member:edit",
    "member:invite",
    "member:delete",
    "worker:view",
    "worker:edit",
    "worker:invite",
    "worker:delete",
    "project:create"
] as const

export type OrgPermissionScope = typeof OrgPermissionScopes[number]

const permissions: { [key in OrgPermissionScope]: APIOrgMemberRole[] } = {
    "member:view": ["OWNER"],
    "member:edit": ["OWNER"],
    "member:invite": ["OWNER"],
    "member:delete": ["OWNER"],
    "worker:view": ["OWNER"],
    "worker:edit": ["OWNER"],
    "worker:invite": ["OWNER"],
    "worker:delete": ["OWNER"],
    "project:create": ["OWNER"]
}

export function hasOrgPermission(
    role: APIOrgMemberRole,
    requiredScope: OrgPermissionScope
): boolean {
    return permissions[requiredScope].includes(role)
}
